import { createFileRoute } from '@tanstack/react-router';

// 開発チケット詳細 > ドキュメントの編集画面。
// URL search は持たない（候補ダイアログ内検索はローカル state で完結）ため
// ここではルート定義のみ。コンポーネントは index.lazy.tsx で遅延ロードする。
export const Route = createFileRoute('/_stacktrace/development-tickets/$ticketId/_layout/documents/edit/')({});